import { LoadingWrapper } from "@vapor/react-contrib-tax-compliance";
import Typography from "@vapor/react-extended/ExtendedTypography";
import { Box, List, ListItem, Stack, useTheme } from "@vapor/react-material";
import { type ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { useGetLinkableTaxPayers } from "../../../../../core/api/use-get-linkable-tax-payers/useGetLinkableTaxPayers";
import { FulfilmentAssociationTaxPayer } from "../fulfilment-linking-tax-payer/FulfilmentLinkingTaxPayer";

const EmptyData = (): ReactElement => {
    const theme = useTheme();
    const { t } = useTranslation();

    return (
        <Box
            sx={{
                textAlign: "center",
            }}
        >
            <Typography
                color={theme.palette.primary.textTitleColor}
                variant="h5"
            >
                {t("views.home.components.fulfilment_association.no_taxPayers")}
            </Typography>
        </Box>
    );
};

export interface FulfilmentAssociationProps {
    levyId: string;
    year: number;
}

export const FulfilmentAssociation = ({
    levyId,
    year,
}: FulfilmentAssociationProps): ReactElement => {
    const { data: taxPayers, isFetching: isLoading } = useGetLinkableTaxPayers({
        levyId,
        year,
    });

    return (
        <Stack spacing={4}>
            <LoadingWrapper loading={isLoading} variant="skeleton-list">
                {taxPayers && taxPayers.length > 0 ? (
                    <List disablePadding style={{ marginTop: 0 }}>
                        {taxPayers.map((taxPayer) => (
                            <ListItem
                                key={taxPayer.workspaceId}
                                disableGutters
                                sx={{
                                    "&.MuiListItem-root": {
                                        padding: 0,
                                        border: "1px solid #B9C8D0",
                                        borderLeft: "1px solid transparent",
                                        borderRight: "1px solid transparent",
                                    },
                                    "&.MuiListItem-root:hover": {
                                        borderLeft: "1px solid transparent",
                                        borderRight: "1px solid transparent",
                                    },
                                }}
                            >
                                <FulfilmentAssociationTaxPayer
                                    levyId={levyId}
                                    taxPayer={taxPayer}
                                    year={year}
                                />
                            </ListItem>
                        ))}
                    </List>
                ) : (
                    <EmptyData />
                )}
            </LoadingWrapper>
        </Stack>
    );
};
